import React, { useState } from 'react';
import { Button } from '@member-portal/ui';
import { RequestModal } from '@/components/RequestModal/index';
import { apiClient } from '@/services/apiClient';

interface SubmitRequestButtonProps {
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  children?: React.ReactNode;
  initialPreferredHotel?: string; // Pre-fill preferred hotel (e.g. from hotel detail page)
  vendorId?: string; // Optional vendor ID (hotel ID when on hotel page)
}

export function SubmitRequestButton({
  variant = 'primary',
  size = 'md',
  className,
  children = 'Request Booking',
  initialPreferredHotel,
  vendorId,
}: SubmitRequestButtonProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleSubmitRequest = async (formData: any) => {
    try {
      await apiClient.post('/api/fhxd-requests', formData);

      // Track successful request submission
      // Only include fields that have actual values (not empty/undefined/null)
      const populatedFields = Object.fromEntries(
        Object.entries(formData).filter(([_, value]) => {
          // Filter out empty values
          if (value === undefined || value === null || value === '') return false;
          // Filter out empty arrays
          if (Array.isArray(value) && value.length === 0) return false;
          return true;
        })
      );

      // Prepare individual field properties for Mixpanel
      const fieldProperties: Record<string, any> = {};
      Object.entries(populatedFields).forEach(([key, value]) => {
        // Prefix each field with "field_" to avoid conflicts and make them queryable
        fieldProperties[`field_${key}`] = value;
      });

      console.log('Request submitted successfully');
    } catch (error) {
      console.error('Failed to submit request:', error);
      throw error; // Re-throw to let the modal handle the error state
    }
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={handleButtonClick}
      >
        {children}
      </Button>

      <RequestModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        onSubmit={handleSubmitRequest}
        initialPreferredHotel={initialPreferredHotel}
        vendorId={vendorId}
      />
    </>
  );
}
